import React from 'react';

import { VirtualAccountDetails } from '@/Screens/Dashboard/Home/VirtualAccountDetails';
import { WalletDetails } from '@/Screens/Dashboard/Home/WalletDetails';
import { CurrencyCodeType } from '@/types/currency';

interface Props {
  readonly currency: CurrencyCodeType;
  readonly beneficiaryId?: string;
}

export const AccountDetailsModal: React.FC<Props> = (props: Props): React.ReactElement => {
  const { currency, beneficiaryId } = props;

  switch (currency) {
    case CurrencyCodeType.USD:
      if (beneficiaryId) {
        return <VirtualAccountDetails beneficiaryId={beneficiaryId} />;
      }

      return <></>;

    case CurrencyCodeType.USDC:
    case CurrencyCodeType.USDT:
      return <WalletDetails currency={currency} beneficiaryId={beneficiaryId} />;

    default:
      console.warn('unsupported currency, cannot show details for: ', currency);
      return <></>;
  }
};
